// External Dependencies
import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

// Icons and UI Components
// import { IoArrowBackOutline } from 'react-icons/io5'
import { MdOutlineAddCircleOutline } from 'react-icons/md'

// Custom Components
import UserTable from '../../components/User'
import PageHeader from '../../components/Custom/PageHeader/PageHeader'
import LinkButton from '../../components/Custom/Buttons/LinkButton'
import CustomToast from '../../components/Custom/CustomToast'

// Hooks and Utils
// import useGoBack from '../../hooks/useGoBack'
import axiosInterceptorInstance from '../../utils/axios/axiosInterceptorInstance'
import useUserStore from '../../utils/state/useUserStore'

const User = () => {
  // Hooks
  const navigate = useNavigate()
  // const GoBack = useGoBack()
  const userPermissions = useUserStore((state) => state.user) || []

  // State Management
  const [isLoading, setLoading] = useState(true)
  const [userList, setUserList] = useState([])

  // Fetch users data
  const fetchUsers = useCallback(async () => {
    try {
      const response = await axiosInterceptorInstance.get('/users')
      setUserList(response.data.length > 0 ? response.data : [])
    } catch (error) {
      CustomToast({
        message: 'Failed to fetch users. Please try again later.',
        type: 'error',
      })
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  // Handle user deletion
  const handleDelete = async (id) => {
    if (!userPermissions.includes('user:delete')) {
      CustomToast({
        message: 'You do not have permission to delete users.',
        type: 'error',
      })
      return
    }

    try {
      await axiosInterceptorInstance.delete(`/users/user/${id}`)
      setUserList((prevUsers) => prevUsers.filter((user) => user._id !== id))
      CustomToast({
        message: 'User deleted successfully.',
        type: 'success',
      })
      navigate('/user')
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        'Failed to delete user. Please try again!'
      CustomToast({
        message: errorMessage,
        type: 'error',
      })
    }
  }

  return (
    <div>
      <PageHeader>
        <div className='flex gap-2 items-center justify-between w-full'>
          <div className='flex gap-2 items-center font-medium'>
            <h1 className='text-2xl'>User Management</h1>
          </div>
          {userPermissions.includes('user:create') && (
            <LinkButton
              icon={<MdOutlineAddCircleOutline className='text-xl' />}
              to='/user/add'
              label='Add User'
            />
          )}
        </div>
      </PageHeader>

      {isLoading ? (
        <p className='text-center my-20'>Loading users...</p>
      ) : (
        <UserTable
          data={userList}
          onDelete={handleDelete}
          userPermissions={userPermissions}
        />
      )}
    </div>
  )
}

export default User
